import whitelogo from '../assets/whitelogo.png';
import blacklogo from '../assets/blacklogo.png';
import propic from '../assets/propic.jpg';
import whiteline from '../assets/whiteline.png';
import blackline from '../assets/blackline.png';
import matterhorn from '../assets/matterhorn.jpg';
import culture from '../assets/culture.png';
import makentu from '../assets/makentu.png';
import astronaut from '../assets/astronaut.png';
import makentupage from '../assets/makentu-page.png';
import paintingpage from '../assets/painting-page.png';
import culturepage from '../assets/culture-page.png';
import ntueenight from '../assets/ntueenight.png';
import ntueenightpage from '../assets/ntueenight-page.png';



export default {
    whitelogo,
    blacklogo,
    propic,
    whiteline,
    blackline,
    matterhorn,
    culture,
    makentu,
    astronaut,
    makentupage,
    paintingpage,
    culturepage,
    ntueenightpage,
    ntueenight,
};